module.exports = __webpack_public_path__ + "images/mdj/members/resume/quick_resume/icon_submit_scout-b44099ca950655d8fc6e9a6f987859e7.png";